import { SizeProp } from "@fortawesome/fontawesome-svg-core";
import { faArrowUp } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { WaypointStep } from "../../../models/WaypointStep";
import { mapsIcons } from "../../Helper/FontAwesomeMapsIcons";

interface WaypointManeuverIconProps {
    waypointStep: WaypointStep;
    stepIndex: number;
    size?: SizeProp;
    color?: string;
    // Shows the step number for icon-less steps, where it reads as a list position rather than a direction.
    numberFallback?: boolean;
}

export default function WaypointManeuverIcon({
    waypointStep,
    stepIndex,
    size,
    color,
    numberFallback = false,
}: WaypointManeuverIconProps) {
    if (!waypointStep.icon || !mapsIcons[waypointStep.icon]) {
        return numberFallback ? (
            <span className="font-bold tabular-nums">{stepIndex}</span>
        ) : (
            <FontAwesomeIcon icon={faArrowUp} size={size} color={color} />
        );
    }

    return (
        <FontAwesomeIcon
            icon={mapsIcons[waypointStep.icon]}
            size={size}
            color={color}
            transform={{ rotate: waypointStep.iconRotate || 0 }}
        />
    );
}
